export const AUTH = {
    emailInput: "login-email-input",
    passwordInput: "login-password-input",
    submit: "login-submit-button",
    error: "login-error-message",
    logout: "logout-button",
};

export const NAV = {
    sidebar: "app-sidebar",
    dashboard: "nav-dashboard",
    projects: "nav-projects",
    tenders: "nav-tenders",
    commercial: "nav-commercial",
    engineering: "nav-engineering",
    reporting: "nav-reporting",
    aiAssistant: "nav-ai-assistant",
};

export const DASH = {
    root: "dashboard-root",
    kpiCard: (k) => `kpi-${k}`,
    generateBrief: "generate-executive-brief",
    briefOutput: "executive-brief-output",
};

export const AI = {
    toggle: "ai-assistant-toggle",
    panel: "ai-assistant-panel",
    input: "ai-assistant-input",
    send: "ai-assistant-send",
    messages: "ai-assistant-messages",
    close: "ai-assistant-close",
};

export const PROJECTS = {
    row: (id) => `project-row-${id}`,
    detailRoot: "project-detail-root",
};

export const TENDERS = {
    row: (id) => `tender-row-${id}`,
    analyzeBtn: (id) => `tender-analyze-${id}`,
};

export const REPORT = {
    generateBtn: (key) => `report-generate-${key}`,
    output: "report-output",
};

// Enterprise Delivery Intelligence™ — additive test ids (isolated to /edi)
export const EDI = {
    navHub: "nav-edi-hub",
    navDashboard: "nav-edi-dashboard",
    navBusinessValue: "nav-edi-business-value",
    navCaptureOnce: "nav-edi-capture-once",
    navReuseSavings: "nav-edi-reuse-savings",
    navKnowledgeReuse: "nav-edi-knowledge-reuse",
    navEnterpriseValue: "nav-edi-enterprise-value",
    navEngineeringProductivity: "nav-edi-engineering-productivity",
    navExecutiveDemo: "nav-edi-executive-demo",
    hub: "edi-hub-root",
    goDashboard: "edi-go-dashboard",
    goBusinessValue: "edi-go-business-value",
    goCaptureOnce: "edi-go-capture-once",
    goBaseline: "edi-go-baseline",
    goEnterpriseValue: "edi-go-enterprise-value",
    goExecutiveDemo: "edi-go-executive-demo",
    moduleCard: (k) => `edi-module-card-${k}`,
    dashboardRoot: "edi-dashboard-root",
    businessValueRoot: "edi-business-value-root",
    reuseSavingsRoot: "edi-reuse-savings-root",
    knowledgeReuseRoot: "edi-knowledge-reuse-root",
    moduleRoot: "edi-module-root",
    captureOnceRoot: "edi-capture-once-root",
    captureOnceTrigger: "edi-capture-once-trigger",
    captureOnceReset: "edi-capture-once-reset",
    captureOnceSurface: (i) => `edi-capture-once-surface-${i}`,
    baselineRoot: "edi-baseline-root",
    baselineType: "edi-baseline-type",
    baselineScale: "edi-baseline-scale",
    baselineClient: "edi-baseline-client",
    baselineRegion: "edi-baseline-region",
    baselineGenerate: "edi-baseline-generate",
    baselineExport: "edi-baseline-export-pdf",
    boardPackRoot: "edi-board-pack-root",
    boardPackSection: (k) => `edi-board-pack-section-${k}`,
    boardPackExport: (k) => `edi-board-pack-export-${k}`,
    kpi: (k) => `edi-kpi-${k}`,
    aiPrompt: (moduleKey, i) => `edi-ai-prompt-${moduleKey}-${i}`,
    aiCustomInput: "edi-ai-custom-input",
    aiCustomSubmit: "edi-ai-custom-submit",
    searchInput: "edi-search-input",
    searchSubmit: "edi-search-submit",
    pillar: (k) => `edi-pillar-${k}`,

    // Phase 2 — Knowledge Lifecycle
    lifecycleRoot: "edi-lifecycle-root",
    lifecycleStage: (k) => `edi-lifecycle-stage-${k}`,

    // Phase 2 — SharePoint Sync
    sharepointRoot: "edi-sharepoint-root",
    sharepointSync: "edi-sharepoint-sync",

    // Phase 2 — Data Sheet Intelligence
    datasheetRoot: "edi-datasheet-root",
    datasheetCommodity: "edi-datasheet-commodity",
    datasheetEquipment: "edi-datasheet-equipment",
    datasheetGenerate: "edi-datasheet-generate",
    datasheetExport: "edi-datasheet-export-pdf",

    // Phase 2 — Engineering Productivity
    engineeringProductivityRoot: "edi-engineering-productivity-root",

    // Phase 2 — Process Plant Baseline Generator
    plantBaselineRoot: "edi-plant-baseline-root",
    plantBaselineCommodity: "edi-plant-baseline-commodity",
    plantBaselineProcess: "edi-plant-baseline-process",
    plantBaselineCapacity: "edi-plant-baseline-capacity",
    plantBaselineClient: "edi-plant-baseline-client",
    plantBaselineLocation: "edi-plant-baseline-location",
    plantBaselineGenerate: "edi-plant-baseline-generate",
    plantBaselineExport: "edi-plant-baseline-export-pdf",

    // Phase 2 — Digital Engineering Twin
    twinRoot: "edi-twin-root",
    twinProjectSelect: (k) => `edi-twin-project-${k}`,

    // Phase 2 — Enterprise Value Dashboard
    enterpriseValueRoot: "edi-enterprise-value-root",

    // Phase 2 — Executive Demonstration
    executiveDemoRoot: "edi-executive-demo-root",
    executiveDemoTrigger: "edi-executive-demo-trigger",
    executiveDemoReset: "edi-executive-demo-reset",
    executiveDemoStage: (i) => `edi-executive-demo-stage-${i}`,
    executiveDemoScenario: (k) => `edi-executive-demo-scenario-${k}`,
    executiveDemoAutoplay: "edi-executive-demo-autoplay",
    executiveDemoPresentation: "edi-executive-demo-presentation",
    executiveDemoNarration: "edi-executive-demo-narration",
    executiveDemoNext: "edi-executive-demo-next",
    executiveDemoRecord: "edi-executive-demo-record",
    executiveDemoRecordStop: "edi-executive-demo-record-stop",
    executiveDemoRecordServer: "edi-executive-demo-record-server",
    executiveDemoExport: (fmt) => `edi-executive-demo-export-${fmt}`,
    executiveDemoLanguage: "edi-executive-demo-language",
    executiveDemoVoice: "edi-executive-demo-voice",
    executiveDemoAudioToggle: "edi-executive-demo-audio-toggle",
    executiveDemoPackage: "edi-executive-demo-package",

    // Phase 3 — Twin drill-down
    twinAssetRow: (tag) => `edi-twin-asset-row-${tag}`,
    twinDrilldownRoot: "edi-twin-drilldown-root",
    twinDrilldownClose: "edi-twin-drilldown-close",

    // Phase 3 — Board Brief
    navBoardBrief: "nav-edi-board-brief",
    boardBriefRoot: "edi-board-brief-root",
    boardBriefGenerate: "edi-board-brief-generate",
    boardBriefExport: (fmt) => `edi-board-brief-export-${fmt}`,

    // Phase 3 — Knowledge Intelligence
    navKnowledgeIntelligence: "nav-edi-knowledge-intelligence",
    knowledgeIntelligenceRoot: "edi-knowledge-intelligence-root",
    knowledgeKpi: (k) => `edi-knowledge-kpi-${k}`,

    // Phase 3 — Value Calculator
    navValueCalculator: "nav-edi-value-calculator",
    valueCalculatorRoot: "edi-value-calculator-root",
    valueCalculatorSlider: (k) => `edi-value-calculator-${k}`,

    // Phase 3 — Intellectual Capital
    navIntellectualCapital: "nav-edi-intellectual-capital",
    intellectualCapitalRoot: "edi-intellectual-capital-root",

    // Phase 4 — Board Room
    navBoardRoom: "nav-edi-board-room",
    boardRoomRoot: "edi-board-room-root",
    boardRoomGenerate: "edi-board-room-generate",
    boardRoomExport: (fmt) => `edi-board-room-export-${fmt}`,

    // Phase 4 — AI Executive Advisor
    navAiAdvisor: "nav-edi-ai-advisor",
    aiAdvisorRoot: "edi-ai-advisor-root",
    aiAdvisorPreset: (k) => `edi-ai-advisor-preset-${k}`,
    aiAdvisorCustomInput: "edi-ai-advisor-custom-input",
    aiAdvisorCustomSubmit: "edi-ai-advisor-custom-submit",
    aiAdvisorAnswer: "edi-ai-advisor-answer",

    // Phase 4 — Reuse Intelligence
    navReuseIntelligence: "nav-edi-reuse-intelligence",
    reuseIntelligenceRoot: "edi-reuse-intelligence-root",
    reuseIntelCommodity: "edi-reuse-intel-commodity",
    reuseIntelProcess: "edi-reuse-intel-process",
    reuseIntelClient: "edi-reuse-intel-client",
    reuseIntelCapacity: "edi-reuse-intel-capacity",

    // Phase 4 — Demonstration Centre
    navDemoCentre: "nav-edi-demo-centre",
    demoCentreRoot: "edi-demo-centre-root",
    demoCentreCard: (k) => `edi-demo-centre-card-${k}`,

    // Phase 4 — Acceptance Audit
    navAcceptanceAudit: "nav-edi-acceptance-audit",
    acceptanceAuditRoot: "edi-acceptance-audit-root",
    acceptanceAuditRun: "edi-acceptance-audit-run",
    acceptanceAuditExport: (fmt) => `edi-acceptance-audit-export-${fmt}`,

    // Phase 4 — Intellectual Capital Heat Map
    icHeatmapRoot: "edi-ic-heatmap-root",

    // Phase 4 — SharePoint mode indicator
    sharepointMode: "edi-sharepoint-mode",

    // Phase 4 — Executive Production Readiness Certification
    navCertification: "nav-edi-certification",
    certificationRoot: "edi-certification-root",
    certificationSignature: "edi-certification-signature",
    certificationQr: "edi-certification-qr",
    certificationExport: (fmt) => `edi-certification-export-${fmt}`,

    // Phase 5 — Executive Capability Maturity Matrix
    navCapabilityMaturity: "nav-edi-capability-maturity",
    capabilityMaturityRoot: "edi-capability-maturity-root",
    capabilityMaturityExport: (fmt) => `edi-capability-maturity-export-${fmt}`,

    // Phase 6 — Client Portal
    navClientPortal: "nav-edi-client-portal",
    clientPortalRoot: "edi-client-portal-root",
    clientPortalSelect: (k) => `edi-client-portal-select-${k}`,

    // Phase 6.6 — Enterprise Certificate Lifecycle
    certLifecycleStatus:      "cert-verify-lifecycle-status",
    certLifecycleReview:      "cert-lifecycle-review",
    certLifecycleRenew:       "cert-lifecycle-renew",
    certLifecycleRevoke:      "cert-lifecycle-revoke",
    certLifecycleReplace:     "cert-lifecycle-replace",
    certLifecycleRow:         (id) => `cert-registry-row-${id}`,
    certRegistryRoot:         "edi-cert-registry-root",
};
